import { useState } from 'react';
import { useBookingLookup } from './useCatalogue';
import { money, dateTime } from '../lib/format';
import { StatusBadge, Spinner } from '../components/ui';
import { ApiRequestError } from '../lib/api';

export function BookingLookupPage() {
  const lookup = useBookingLookup();
  const [bookingNumber, setBookingNumber] = useState('');
  const [mobile, setMobile] = useState('');
  const [err, setErr] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    try {
      await lookup.mutateAsync({ bookingNumber: bookingNumber.trim(), mobile: mobile.trim() });
    } catch (e2) {
      setErr(e2 instanceof ApiRequestError ? e2.message : 'Lookup failed');
    }
  };

  const b = lookup.data;

  return (
    <div className="mx-auto max-w-md px-4 py-10">
      <h1 className="text-xl font-semibold text-ink-900">Track a booking</h1>
      <p className="mt-1 text-sm text-ink-500">
        Enter your booking number and the mobile number you used.
      </p>

      <form onSubmit={onSubmit} className="mt-5 space-y-3">
        <label className="block">
          <span className="label">Booking number</span>
          <input
            className="input"
            placeholder="EXPO-2026-000125"
            value={bookingNumber}
            onChange={(e) => setBookingNumber(e.target.value)}
          />
        </label>
        <label className="block">
          <span className="label">Mobile number</span>
          <input
            className="input"
            inputMode="tel"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
        </label>
        <button className="btn-gold w-full" disabled={lookup.isPending}>
          {lookup.isPending ? <Spinner className="h-4 w-4" /> : 'Find booking'}
        </button>
        {err && <p className="text-sm text-red-600">{err}</p>}
      </form>

      {b && (
        <div className="card mt-6 p-4">
          <div className="flex items-center justify-between">
            <span className="font-mono text-sm font-semibold">{b.bookingNumber}</span>
            <StatusBadge status={b.status} />
          </div>
          <div className="mt-3 space-y-2 border-t border-ink-100 pt-3">
            {b.items.map((it, i) => (
              <div key={i} className="flex justify-between text-sm">
                <span className="min-w-0 line-clamp-1">
                  {it.productName} · ×{it.quantity}
                </span>
                <span className="shrink-0 font-medium">{money(it.lineTotal)}</span>
              </div>
            ))}
          </div>
          <div className="mt-3 flex justify-between border-t border-ink-100 pt-3 text-sm font-semibold">
            <span>Total</span>
            <span>{money(b.totalAmount)}</span>
          </div>
          <p className="mt-2 text-[11px] text-ink-400">Placed {dateTime(b.createdAt)}</p>
        </div>
      )}
    </div>
  );
}
